export default function AnswerFrame() {
    return <svg data-name="answer-frame">
        <polygon className="cls-4" points="389.7 232.22 10.01 258.85 10.62 0 397.55 16.4 389.7 232.22"/>
    </svg>;
}
